import React, { useState } from 'react'
import ModalModificarOtrosPariticipantesDQ from './ModalModificarOtrosPariticipantesDQ'
import ModalEliminarOtrosParticipantesDQX from './ModalEliminarOtrosParticipantesDQX'

const TablaOtrosParticipantesDX = ({item,passActualizarOtrosParticipantes}) => {
  const [modalOnModificarOtrosParticipantes, setmodalOnModificarOtrosParticipantes]=useState(false)
  const [modalOnEliminarOtrosParticipantes, setmodalOnEliminarOtrosParticipantes]=useState(false)
  const handleOnclickModificarOtrosPartipantes =()=>{
    setmodalOnModificarOtrosParticipantes(true)
  }
  const handleOnclickEliminarOtrosParticipantes=()=>{
    setmodalOnEliminarOtrosParticipantes(true)
  }
  return (
    <>
      <tr  className=" divide-y divide-slate-700" >
        <td></td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        <button
          onClick={handleOnclickModificarOtrosPartipantes}
            type="button"
            className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Modificar
          </button>
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          <button
            type="button"
            onClick={handleOnclickEliminarOtrosParticipantes}
            className="inline-block px-3 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Eliminar 
          </button>
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
          {item.PersCod}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
          {item.PersNom}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
          {item.PersTip}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
          {item.PersTipDes}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
          {/* {item.PersTipDes} */}
          {item.PersEst == 'S'? 'Si': 'No'}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
          {item.PersEsp}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
          {item.PersNomEP}
        </td>
      </tr>
    {modalOnModificarOtrosParticipantes? <ModalModificarOtrosPariticipantesDQ setmodalOnModificarOtrosParticipantes={setmodalOnModificarOtrosParticipantes} item={item} passActualizarOtrosParticipantes={passActualizarOtrosParticipantes}/>:null}
    {modalOnEliminarOtrosParticipantes? <ModalEliminarOtrosParticipantesDQX setmodalOnEliminarOtrosParticipantes={setmodalOnEliminarOtrosParticipantes} item={item} passActualizarOtrosParticipantes={passActualizarOtrosParticipantes}/>:null}
    </>
  )
}

export default TablaOtrosParticipantesDX